import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'
import { TYPES } from '@md/users/constances'

const List = () => import('./views/List')
const Display = () => import('./views/Display')
const HistoryList = () => import('./views/HistoryList')

const ROUTE_NAME = 'profile:orders:'

const p = name => ROUTE_NAME + name

const LIST = p('list')
const DISPLAY = p('display')
const HISTORY = p('history')

export function createRoutes(options) {
  return [
    route('history/', HistoryList, HISTORY, {
      meta: {
        label: 'ORDERS_HISTORY',
        accessConfig: accessPermission([TYPES.DEALER], options),
      },
    }),
    route('list/', List, LIST, {
      meta: {
        label: 'ORDERS_LIST',
        accessConfig: accessPermission([TYPES.DEALER], options),
      },
    }),
    route(':id/detail/', Display, DISPLAY, {
      props: true,
      meta: {
        label: 'ORDERS_DISPLAY',
        accessConfig: accessPermission([TYPES.DEALER], options),
      },
    }),
  ]
}
